import EngagorCase from './engagor-case';
import EngagorCaseAction from './engagor-case-action';
import * as _ from 'underscore';

export class EngagorCaseUtils {
	static getCloseAction(caseItem: EngagorCase): EngagorCaseAction {
		let closeAction = _.chain(caseItem.actions).filter(action => action.type === 'status').last().value();
		return closeAction?.metadata?.status === 'done' ? closeAction : null;
	}
}